import { Button, VStack } from "@chakra-ui/react";
import { format } from "date-fns";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import * as yup from "yup";
import { ColorField } from "../components/inputs/input-color";
import { InputField } from "../components/inputs/input-field";
import { useColletion } from "../hooks/usePocketBase";


export const FormularioEditarTarefa = ({ tarefa, onClose }: { tarefa: any, onClose: () => void }) => {

    const { updateDoc } = useColletion('tarefas');

    //@ts-ignore
    const initialValues: any = {
        id: tarefa?.id,
        titulo: tarefa.titulo,
        descricao: tarefa.descricao,
        finalizado: tarefa?.finalizado,
        //@ts-ignore
        data: tarefa?.data ? format(new Date(tarefa?.data), "yyyy-MM-dd' 'hh:mm") : tarefa.data_de ? format(new Date(tarefa?.data_de), "yyyy-MM-dd' 'hh:mm") : format(new Date(), "yyyy-MM-dd' 'hh:mm"),
        //@ts-ignore
        data_de: tarefa?.data_de ? format(new Date(tarefa?.data_de), "yyyy-MM-dd' 'hh:mm") : tarefa.data ? format(new Date(tarefa?.data), "yyyy-MM-dd' 'hh:mm") : format(new Date(), "yyyy-MM-dd' 'hh:mm"),
        //@ts-ignore
        data_ate: tarefa?.data_ate ? format(new Date(tarefa?.data_ate), "yyyy-MM-dd' 'hh:mm") : format(new Date(), "yyyy-MM-dd' 'hh:mm"),
        cor: tarefa?.cor,
        //@ts-ignore
        global: tarefa?.global,
        tipo: 'dia'
    }

    const validationSchema = yup.object().shape({
        titulo: yup.string().min(1, 'Campo obrigatório').required('Campo obrigatório'),
        descricao: yup.string().min(1, 'Campo obrigatório').required('Campo obrigatório'),
    })

    const onSubmit = async (values: any) => {
        let valores = { ...values };
        if (values?.tipo === 'dia') {
            valores.data_de = null;
            valores.data_ate = null;
            if (valores?.data?.includes(" ")) {
                valores.data = new Date(valores?.data?.replace(" ", "T"));
            } else {
                valores.data = new Date(valores?.data)
            }
        }
        if (values?.tipo === 'periodo') {
            valores.data = null;
            if (valores?.data_de?.includes(" ")) {
                valores.data_de = new Date(valores?.data_de?.replace(" ", "T"));

            } else {
                valores.data_de = new Date(valores?.date_de);
            }
            if (valores?.data_ate?.includes(" ")) {
                valores.data_ate = new Date(valores?.data_ate?.replace(" ", "T"));
            } else {
                valores.data_ate = new Date(valores?.data_ate);
            }
        }

        await updateDoc(tarefa?.id, valores)
            .then(() => {
                onClose()
                formik.resetForm();

            })


    }

    const formik = useFormik({
        initialValues,
        onSubmit,
        validationSchema
    })


    return (
        <form onSubmit={formik.handleSubmit}>
            <VStack
                w={`100%`}
                spacing={5}
                pt={1}
                px={2}
                pb={3}
                overflowY={`auto`}
            >

                <InputField
                    autoFocus
                    name='titulo'
                    value={formik.values.titulo}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    //@ts-ignore
                    error={formik?.errors?.titulo}
                    label='Titulo'
                    isDisabled={formik.isSubmitting}
                    isRequired
                />

                <InputField
                    autoFocus
                    name='data'
                    value={formik.values.data}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    //@ts-ignore
                    error={formik?.errors?.data}
                    label='Data'
                    isDisabled={formik.isSubmitting}
                    isRequired
                    type="datetime-local"
                />

                <InputField
                    name='descricao'
                    value={formik.values.descricao}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    //@ts-ignore
                    error={formik?.errors?.descricao}
                    label='Descrição'
                    isDisabled={formik.isSubmitting}
                    isRequired
                    isTextArea
                    resize='vertical'

                />
                <ColorField
                    name='cor'
                    value={formik.values.cor}
                    onChange={(e) => {
                        formik.setFieldValue('cor', e)
                    }}
                    onBlur={formik.handleBlur}
                    //@ts-ignore
                    error={formik?.errors?.cor}
                    label='Cor'
                    isDisabled={formik?.isSubmitting}

                />

                <Button
                    w={`full`}
                    size={`md`}
                    type="submit"
                    bg={`green.500`}
                    borderColor={`green.500`}
                    borderWidth={1}
                    _hover={{
                        color: 'green.500',
                        borderColor: 'green.500',
                        bg: 'transparent'
                    }}
                >
                    Editar
                </Button>
            </VStack>

        </form>
    )
}